export function parseDonorPortalSearchPayload(data) {
  if (Array.isArray(data)) {
    return { results: data, suggestions: [] }
  }

  return {
    results: data?.results ?? [],
    suggestions: data?.suggestions ?? [],
  }
}
